import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, Mail, Search } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";
import { Logo } from "./Logo";
import { NAV, ORG } from "../../data/content";

const linkCls = ({ isActive }) =>
  `relative whitespace-nowrap px-3 py-3 text-[13px] font-semibold transition-colors duration-200 ${isActive ? "text-royal" : "text-slate-700 hover:text-royal"}`;

const TopBar = () => (
  <div className="bg-navy text-slate-300 text-xs no-print">
    <div className="container-x flex h-9 items-center justify-between gap-4">
      <span className="truncate"><span className="text-emerald-300 font-semibold">Affiliated to STU</span> – Swatantra Thozhilali Union</span>
      <div className="hidden md:flex items-center gap-5">
        <a href={`tel:+91${ORG.phone}`} className="flex items-center gap-1.5 hover:text-white" data-testid="topbar-phone"><Phone className="h-3.5 w-3.5" />{ORG.phoneDisplay}</a>
        <a href={`mailto:${ORG.email}`} className="flex items-center gap-1.5 hover:text-white" data-testid="topbar-email"><Mail className="h-3.5 w-3.5" />{ORG.email}</a>
      </div>
    </div>
  </div>
);

const MobileNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button className="xl:hidden rounded-lg border border-slate-200 p-2 text-navy" aria-label="Open menu" data-testid="mobile-menu-button">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[300px] overflow-y-auto">
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <nav className="mt-8 flex flex-col">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)}
              className={({ isActive }) => `border-b border-slate-100 py-3 text-sm font-semibold ${isActive ? "text-royal" : "text-navy"}`}
              data-testid={`mobile-nav-${n.to === "/" ? "home" : n.to.slice(1)}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/membership?tab=track" onClick={() => setOpen(false)} className="btn-outline mt-6" data-testid="mobile-track-link">Track Application</Link>
          <Link to="/membership" onClick={() => setOpen(false)} className="btn-green mt-3" data-testid="mobile-join-link">Join the Federation</Link>
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export const Header = () => (
  <header className="sticky top-0 z-50 no-print">
    <TopBar />
    <div className="border-b border-slate-200/80 bg-white/95 backdrop-blur-md">
      <div className="container-x flex h-[72px] items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo-link"><Logo /></Link>
        <div className="flex items-center gap-2">
          <Link to="/membership?tab=track" className="hidden sm:inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold text-navy hover:bg-slate-100" data-testid="header-track-link">
            <Search className="h-3.5 w-3.5" /> Track
          </Link>
          <Link to="/membership" className="hidden sm:inline-flex btn-green !px-4 !py-2.5" data-testid="header-join-button">Join Now</Link>
          <MobileNav />
        </div>
      </div>
      <div className="hidden xl:block border-t border-slate-100">
        <nav className="container-x flex items-center justify-between" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} className={linkCls} data-testid={`nav-${n.to === "/" ? "home" : n.to.slice(1)}`}>{n.label}</NavLink>
          ))}
        </nav>
      </div>
    </div>
  </header>
);
